import React from "react";
import {Card, Message, Table} from "rsuite";
import {EventsTableProps, PreparedDeviceEvent} from "./EventsTable.model";
import "./EventsTable.scss";
import {
  DEFAULT_EVENT_LABELS,
  DEFAULT_SENSOR_LABELS,
  prepareEvents
} from "./EventsTable.utils";

const {Column, HeaderCell, Cell} = Table;

const EventsTable = ({
  events = [],
  loading = false,
  deviceId,
  eventLabels = DEFAULT_EVENT_LABELS,
  sensorLabels = DEFAULT_SENSOR_LABELS,
  title = "События устройства",
  emptyMessage = "Событий пока нет"
}: EventsTableProps) => {
  const preparedEvents = prepareEvents(events, eventLabels, sensorLabels);

  return (
    <Card style={{marginTop: 16}}>
      <div className="p-2">
        <strong>{title}</strong>
      </div>

      {!preparedEvents.length && !loading ? (
        <Message type="info" showIcon>
          {emptyMessage}
        </Message>
      ) : (
        <Table
          autoHeight
          bordered
          cellBordered
          hover={false}
          data={preparedEvents}
          loading={loading}
          rowKey="id"
          wordWrap
        >
          <Column width={220}>
            <HeaderCell>Дата и время</HeaderCell>
            <Cell dataKey="formattedTime">
              {(row) => {
                const item = row as PreparedDeviceEvent;
                return item.wrongTime ? (
                  <span className="events-table__wrong-time" title="Часы станции сбились — событие не учитывается в отслеживании стрелок и сбоях">
                    {item.formattedTime}
                    <span className="events-table__wrong-time-note">неверное время устройства</span>
                  </span>
                ) : item.formattedTime;
              }}
            </Cell>
          </Column>

          <Column flexGrow={1} minWidth={260}>
            <HeaderCell>Событие</HeaderCell>
            <Cell dataKey="eventLabel" />
          </Column>

          <Column flexGrow={1} minWidth={260}>
            <HeaderCell>Датчик</HeaderCell>
            <Cell dataKey="sensorLabel" />
          </Column>
        </Table>
      )}
    </Card>
  );
};

export default EventsTable;
